import { useField } from 'formik';
import { useCallback } from 'react';

import { Date as MuiDate, DateProps as MuiDateProps } from '@app/ui/forms/components/Date';

import { useErrorTranslations } from '../../hooks/useErrorTranslations';

export interface DateProps extends Omit<MuiDateProps, 'value' | 'onBlur' | 'onChange'> {
  readonly name: string;
  readonly withLockIcon?: boolean;
}

export const Date = ({ name, label, helperText, ...props }: DateProps) => {
  const [{ value }, { touched, error }, { setValue }] = useField(name);

  const errorHelperText = useErrorTranslations(typeof label === 'string' ? label : name, error);

  const isError = Boolean(touched && errorHelperText);

  const handleChange = useCallback((newValue: string | undefined) => setValue(newValue), []);

  return (
    <MuiDate
      label={label}
      {...props}
      name={name}
      onChange={handleChange}
      error={isError}
      helperText={isError ? errorHelperText : helperText || ''}
      value={value}
    />
  );
};
